import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { processDeliveryDetails } from '../../../selfservice/actions/index.js';
import { DeviceCheckoutDeliveryDetails } from '../../DeviceCheckoutDeliveryDetails/DeviceCheckoutDeliveryDetails.js';
import type { CommonError } from '../../../common/types/errors.js';
import type { DeviceCheckoutDeliveryDetailsType } from '../../DeviceCheckoutDeliveryDetails/DeviceCheckoutDeliveryDetailsUtils.js';

export interface PunchoutDeliveryDetailsProps {
  onSaveDeliveryDetailsAndNext: (updatedDeliveryDetails: DeviceCheckoutDeliveryDetailsType) => void;
  setDeliveryDetailsObj: (updatedDeliveryDetails: DeviceCheckoutDeliveryDetailsType) => void;
  deliveryDetails: DeviceCheckoutDeliveryDetailsType;
  hasPreInstallation?: boolean;
  shipmentTypeSelectionEnabled: boolean;
  showDeliveryDetailsStep?: boolean;
}
export const PunchoutDeliveryDetails = ({
  onSaveDeliveryDetailsAndNext,
  setDeliveryDetailsObj,
  deliveryDetails,
  hasPreInstallation,
  shipmentTypeSelectionEnabled,
  showDeliveryDetailsStep,
}: PunchoutDeliveryDetailsProps) => {
  const dispatch = useDispatch();

  const onSaveDeliveryDetailsToState = useCallback(
    (updatedDeliveryDetails: DeviceCheckoutDeliveryDetailsType, validationErrors?: CommonError[]) => {
      dispatch(processDeliveryDetails(updatedDeliveryDetails, validationErrors));
      setDeliveryDetailsObj(updatedDeliveryDetails);
    },
    [dispatch, setDeliveryDetailsObj]
  );
  return (
    <DeviceCheckoutDeliveryDetails
      deliveryDetails={deliveryDetails}
      saveDeliveryDetailsAndNext={onSaveDeliveryDetailsAndNext}
      saveDeliveryDetailsToState={onSaveDeliveryDetailsToState}
      hasPreInstallation={hasPreInstallation}
      shipmentTypeSelectionEnabled={shipmentTypeSelectionEnabled}
      showDeliveryDetailsStep={showDeliveryDetailsStep}
    />
  );
};
